import React from 'react';
import MembershipLanding from '../../components/membership/MembershipLanding';
import { builders } from '../../components/membership/personaContent';

function BuildersPage() {
  return <MembershipLanding content={builders} />;
}

export default BuildersPage;
